import React from 'react';
import { Link } from '@medely/ui-kit';
import { config } from '@mp/config';
import { HelpCenterLinkProps } from './interface';

export const HelpCenterLink = ({
  configKey,
  url,
  text,
  isLarge,
  color,
  variant = 'text',
}: HelpCenterLinkProps) => {
  let finalURL = url ?? '';
  if (configKey) {
    finalURL = config.help[configKey];
  }

  const size = isLarge ? 'l' : 'm';

  return (
    <Link url={finalURL} variant={variant} size={size} color={color}>
      {text}
    </Link>
  );
};
